// Shared ``accept`` attribute for every image upload input in the app.
//
// WHY EXTENSIONS INSTEAD OF ``image/*``?
// Safari on macOS maps ``image/*`` in a file-picker's accept attribute
// to a fixed set of Uniform Type Identifiers (public.jpeg, public.png,
// public.heif, …). AVIF and a few other newer formats aren't in that
// set on older macOS builds, so files with a ``.avif`` extension are
// rendered GREYED OUT in the Finder picker even when the server would
// gladly accept them. Windows Explorer and Chrome/Firefox on every
// platform honour ``.ext`` patterns literally, so an extension-only
// accept list is the only reliable way to keep every supported format
// selectable in the picker.
//
// Keep this in sync with backend/shared_constants.py:ALLOWED_CONTENT_TYPES.
export const IMAGE_UPLOAD_ACCEPT = [
  // Web-native
  '.jpg', '.jpeg', '.jfif', '.pjpeg',
  '.png', '.gif', '.webp', '.avif', '.svg',
  // Transcoded to JPEG at intake on the server
  '.heic', '.heif',
  '.tif', '.tiff',
  '.bmp',
].join(',');

export default IMAGE_UPLOAD_ACCEPT;
